import {useEffect, useRef} from "react";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {Alert, Button, Link} from "@mui/material";
import {CopyAll, GpsFixed} from "@mui/icons-material";
import useAlert from "../../../../use/useAlert";
import useClipboard from "../../../../use/useClipboard";
import useClientRepository from "../../../../repository/insurance/useClientRepository";
import Typography from "@mui/material/Typography";
import useOrderRepository from "../../../../repository/insurance/useOrderRepository";

export default function ({orderId}) {
    const alert = useAlert();
    const clipboard = useClipboard();
    const clientRepository = useClientRepository();
    const orderRepository = useOrderRepository();
    /** @type Order */
    const order = orderRepository.findOneById(orderId).select();
    /** @type Client */
    const client = clientRepository.findOneById(order?.getClientId()).select();
    const googleMapLink = useRef();

    useEffect(() => {
        orderRepository.findOneById(orderId).exec();
    }, []);

    useEffect(() => {
        if (isNull(order)) return;

        clientRepository.findOneById(order.getClientId()).exec();
    }, [JSON.stringify(order)]);

    const handleOpenMap = () => {
        googleMapLink.current.click();
    }

    const handleCopyCoordinate = () => {
        clipboard(`${client.getLatitude()},${client.getLongitude()}`);

        alert.success("Copié !");
    }

    const handleCopyAddress = () => {
        clipboard(`${client.getLine1()} ${isNull(client.getLine2()) ? "" : client.getLine2()}, ${client.getPostcode()} ${client.getCity()}`);

        alert.success("Copié !");
    }

    if (isNull(order) || isNull(client)) return null;

    return (
        <>
            <Typography textAlign="center" fontWeight={"bold"} variant="h5">
                {client.getName()}
            </Typography>
            <Typography mt={5} textAlign="center">
                {client.getLine1()} {client.getLine2()}, <br/>{client.getPostcode()} {client.getCity()}
            </Typography>
            <Box mt={10} display="flex" justifyContent="center">
                <Button
                    startIcon={<GpsFixed/>}
                    variant="contained"
                    size="small"
                    onClick={handleOpenMap}
                    data-test="insurance-button-open-map"
                    fullWidth={true}
                >
                    Ouvrir mon GPS
                </Button>
            </Box>
            <Box mt={5} display="flex" justifyContent="center">
                <Button
                    startIcon={<CopyAll/>}
                    variant="contained"
                    size="small"
                    onClick={handleCopyCoordinate}
                    fullWidth={true}
                >
                    Copier les coordonnées GPS
                </Button>
            </Box>
            <Box mt={5} display="flex" justifyContent="center">
                <Button
                    startIcon={<CopyAll/>}
                    variant="contained"
                    size="small"
                    onClick={handleCopyAddress}
                    fullWidth={true}
                >
                    Copier l'adresse
                </Button>
            </Box>
            <Link
                ref={googleMapLink}
                href={`https://www.google.com/maps/dir/?api=1&origin=Current%20Location&destination=${client.getLatitude()},${client.getLongitude()}`}
                target={"_blank"}
                color={"inherit"}
                underline={"none"}
            />

            {
                !isNull(order.getDescription())
                    ? (
                        <Box mt={3}>
                            <Alert severity={"info"}>
                                Descriptif : {order.getDescription()}
                            </Alert>
                        </Box>
                    )
                    : null
            }
        </>
    )
}
